import { render, staticRenderFns } from "./SearchResultsComponent.vue?vue&type=template&id=a5f8e9a8&scoped=true"
import script from "./SearchResultsComponent.vue?vue&type=script&lang=js"
export * from "./SearchResultsComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsComponent.vue?vue&type=style&index=0&id=a5f8e9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f8e9a8",
  null
  
)

export default component.exports